<template>
  <div>
    <component :is="readOnly ? 'div' : 'b-form-input'"
               :class="combineClass"
               type="text" class="form-control form-control-sm text-right"
               v-model.trim="valueFromProp"
               @input="valueInputed"
               @change="valueChanged"
               @blur="formatValue">
      {{ valueFromProp | comma(decimalLen) }}
    </component>
    <div v-if="percentage" class="row mx-n1 align-items-center mt-1">
      <div class="col-auto px-1">
        <b-button variant="primary" class="btn-xs gtc-icon-minus"
                  @click="markup--, markupChanged()"
                  :disabled="disabled"></b-button>
      </div>
      <b-form-input size="sm" class="col text-right"
                    v-model.trim="markup" :disabled="disabled"
                    @change="markupChanged()"
                    @blur="markupInputed" />
      <div class="col-auto px-0">%</div>
      <div class="col-auto px-1">
        <b-button variant="primary" class="btn-xs gtc-icon-plus"
                  @click="markup++, markupChanged()"
                  :disabled="disabled"></b-button>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'gtc-number',
    props: {
      readOnly: {
        type: Boolean,
        default: false
      },
      decimalLen: {
        type: Number,
        default: 2
      },
      value: {
        default: null
      },
      base: {
        type: Number,
        default: null
      },
      percentage: {
        type: Boolean,
        default: false
      },
      inputClass: {
        detault: {}
      }
    },
    data: function () {
      return {
        valueFromProp: null,
        percentageDisabled: false,
        markup: null
      }
    },
    computed: {
      combineClass() {
        let result = {
          'bg-gray-150': this.readOnly,
        };
        if (_.isObject(this.inputClass))
          result = {
            ...result,
            ...this.inputClass
          };
        else if (_.isString(this.inputClass)) {
          result[this.inputClass] = true;
        }
        else if (_.isArray(this.inputClass)) {
          _.each(this.inputClass, item => { result[item] = true; });
        }
        return result;

      },
      disabled() {
        return this.readOnly || this.percentageDisabled;
      }
    },
    created() {
      this.valueFromProp = this.value;
      this.formatValue();
      if (this.percentage) this.calculateMarkup();

      if (_.isNaN(Number(this.base)) || Number(this.base) === 0) this.percentageDisabled = true;
    },
    watch: {
      value(newVal, oldVal) {
        if (!this.isEqual(newVal, this.valueFromProp)) {
          this.valueFromProp = newVal;
          this.formatValue();
          if (this.percentage) this.calculateMarkup();
        }
      }
    },
    methods: {
      isEqual(newVal, oldVal) {
        return parseFloat(_.replace(newVal, ',', '')) === parseFloat(_.replace(oldVal, ',', ''));
      },
      formatValue() {
        this.valueFromProp = this.$options.filters['comma'](this.valueFromProp, this.decimalLen);
      },
      markupInputed() {
        let self = this;
        if (self.isNumberLike(self.markup)) {
          this.markupChanged();
        }
      },
      markupChanged() {
        let self = this;
        if (!self.percentageDisabled) {

          if (!self.isNumberLike(self.markup)) {
            self.markup = 0;
          }
          else {
            self.markup = parseFloat(String(self.markup).replace(/[,%]/, ''));
          }
          // this.valueFromProp = this.base * (1 + self.markup / 100);
          if (self.markup === 100){
            self.markup  = 99.999;
          }
          var countDecimals = function (value) { return value % 1 ? value.toString().split(".")[1].length : 0; }
          let numOfDecimals = countDecimals(self.markup);
          if (numOfDecimals > 2) {
            //self.markup = _.round(self.markup, 2);
            self.markup = self.markup.toFixed(2);
          }
          self.valueFromProp = self.base/(1-self.markup/100);
          self.formatValue();
          self.valueChanged();
        }
      },
      calculateMarkup() {
        let self = this;
        if (self.percentageDisabled || Number(self.valueFromProp.replace(/,/g, '')) === 0) {
          if(self.base === 0 ){
            self.markup = '';
          }else{
            self.markup = -100;
          }
        }
        else {
          var countDecimals = function (value) { return value % 1 ? value.toString().split(".")[1].length : 0; }
          // self.markup = _.round(((Number(self.valueFromProp.replace(/,/g, '')) / Number(self.base)) - 1) * 100, self.decimalLen + 1);
          self.markup = _.round(((Number(self.valueFromProp.replace(/,/g, '')) - Number(self.base)) / Number(self.valueFromProp.replace(/,/g, ''))) * 100, self.decimalLen + 1);
          let numOfDecimals = countDecimals(self.markup);
          if (numOfDecimals > 2) {
            //self.markup = _.round(self.markup, 2);
            self.markup = self.markup.toFixed(2);
          }
        }
      },
      valueInputed() {
        let self = this;
        if (self.isNumberLike(self.valueFromProp)) {
          this.valueChanged();
        }
      },
      valueChanged() {
        let self = this;
        if (!self.isNumberLike(self.valueFromProp)) {
          self.valueFromProp = String(self.base || 0);
        }

        self.calculateMarkup();
        self.$emit('input', _.round(Number(self.valueFromProp.replace(/,/g, '')), self.decimalLen));

      },
      isNumberLike(markup) {
        if (markup.length === 0 || markup.length > 100) return false;
        // 安全正則：支援 1234 / 1,234 / 1,234.56 / 1234.56 / 同時可選 % 符號
        const safeRe = /^(?:\d{1,3}(?:,\d{3})*|\d+)(?:\.\d+)?%?$/;
        return safeRe.test(markup);
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/framework/GtcNumber.vue